import { GenericResponse } from "./genericResponse.model";

export interface Country {
  id: number;
  name: string;
  code: string;
  code2: string;
  code2Lower: string;
  dialCode: number;
  placeholder: string;
}


export interface CountryListResponse extends GenericResponse {
  countries: Country[];
}

//export interface CurrentCountryResponse {
//  ip: string;
//  registry: string;
//  countrycode: string;
//  countryname: string;
//  asn: CountryData;
//  spam: boolean;
//  tor: boolean;
//}

export interface CountryData {
  code: number;
  name: string;
  route: string;
  start: string;
  end: string;
  count: number;
}


export interface CurrentCountryResponse {
  as: string
  asname: string
  callingCode: string
  city: string
  continent: string
  continentCode: string
  country: string
  countryCode: string
  countryCode3: string
  currency: string
  currentTime: string
  district: string
  hosting: boolean
  isp: string
  lat: number
  lon: number
  mobile: boolean
  offset: number
  org: string
  proxy: boolean
  query: string
  region: string
  regionName: string
  reverse: string
  status: string
  timezone: string
  zip: string
}
